/* Floretti 3.0 — 10%-aanmeldpopup.

   Verschijnt na een instelbare vertraging, maar nooit meer nadat iemand
   'm heeft weggeklikt of zich heeft aangemeld. In de theme-editor toont hij
   zich direct, anders kun je 'm niet vormgeven. */
(function () {
  'use strict';

  var STORAGE_KEY = 'floretti-promo-dismissed';

  class FlorettiPromoPopup extends HTMLElement {
    connectedCallback() {
      this.overlay = this;
      this.modal = this.querySelector('[data-promo-modal]');
      this.closeBtn = this.querySelector('[data-promo-close]');
      this.declineBtn = this.querySelector('[data-promo-decline]');
      this.emailInput = this.querySelector('input[type="email"]');
      this.successPanel = this.querySelector('[data-promo-success]');

      this.delay = parseInt(this.dataset.delay, 10) || 8;
      this.isEditor = Boolean(window.Shopify && window.Shopify.designMode);
      this.privacyRetryDelay = 2000;

      this.bind();

      // Net aangemeld? Dan meteen tonen met de bevestiging, en niet meer terug.
      // Het succes-element bestaat alleen als Shopify het formulier verwerkt heeft.
      if (this.querySelector('[data-promo-success]')) {
        if (this.declineBtn && this.dataset.successCloseLabel) {
          this.declineBtn.textContent = this.dataset.successCloseLabel;
        }
        this.remember();
        this.open();
        return;
      }

      if (this.isEditor) {
        this.open();
        return;
      }

      if (this.dismissed()) return;
      this.timer = setTimeout(this.openWhenReady.bind(this), this.delay * 1000);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('keydown', this._onKeydown);
    }

    bind() {
      var self = this;

      this._onKeydown = function (event) {
        if (event.key === 'Escape') self.dismiss();
        if (event.key === 'Tab') self.trapFocus(event);
      };

      if (this.closeBtn) this.closeBtn.addEventListener('click', this.dismiss.bind(this));
      if (this.declineBtn) this.declineBtn.addEventListener('click', this.dismiss.bind(this));

      this.addEventListener('click', function (event) {
        if (event.target === self) self.dismiss();
      });

      // Bewaar niet op submit. Storefront forms kunnen eerst hCaptcha tonen; bij
      // een onopgeloste challenge mag de popup niet stilletjes verdwijnen.
    }

    openWhenReady() {
      if (this.isEditor || !this.privacyBannerVisible()) {
        this.open();
        return;
      }

      this.timer = setTimeout(this.openWhenReady.bind(this), this.privacyRetryDelay);
    }

    privacyBannerVisible() {
      var selectors = [
        '#shopify-pc__banner',
        '#shopify-pc__prefs__dialog',
        '.shopify-pc__banner__dialog',
        '[id^="shopify-pc__"]'
      ];

      return selectors.some(function (selector) {
        return Array.prototype.some.call(document.querySelectorAll(selector), function (element) {
          var style = window.getComputedStyle(element);
          var rect = element.getBoundingClientRect();
          return (
            style.display !== 'none' &&
            style.visibility !== 'hidden' &&
            style.opacity !== '0' &&
            rect.width > 1 &&
            rect.height > 1
          );
        });
      });
    }

    open() {
      this.hidden = false;
      if (this.closeBtn) this.closeBtn.disabled = false;
      if (this.declineBtn) this.declineBtn.disabled = false;
      // Forceer een reflow zodat de transitie loopt.
      void this.offsetWidth;
      this.classList.add('is-open');
      this.lastFocused = document.activeElement;
      document.addEventListener('keydown', this._onKeydown);
      if (this.successPanel) {
        this.successPanel.focus();
      } else if (this.emailInput) {
        this.emailInput.focus();
      }
    }

    dismiss() {
      this.classList.remove('is-open');
      this.remember();
      document.removeEventListener('keydown', this._onKeydown);
      if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
      var self = this;
      setTimeout(function () {
        self.hidden = true;
      }, 250);
    }

    dismissed() {
      try {
        return localStorage.getItem(STORAGE_KEY) === '1';
      } catch (e) {
        return false;
      }
    }

    remember() {
      try {
        localStorage.setItem(STORAGE_KEY, '1');
      } catch (e) {
        /* private mode — dan geldt het alleen deze sessie */
      }
    }

    trapFocus(event) {
      if (!this.modal) return;
      var focusable = this.modal.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      );
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  if (!customElements.get('floretti-promo-popup')) {
    customElements.define('floretti-promo-popup', FlorettiPromoPopup);
  }
})();
